import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 *
 * RAP
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#6674
 **/
const SearchApiService = {
    /**
     * 查询 待出货订单 头部
     * @param data
     */
    getContainerOrderTop(data={}) {
        return request({
            url:  '/service/mg/container/orderHead',
            method: "POST",
            data
        });
    },
    /**
     * 待出货订单 详情 获取 采购商下联系人列表
     * @param data
     */
    getPurchaserInfo(data={}) {
        return request({
            url:  '/service/mg/warehouse-management/delivery-details/purchaserInfo',
            method: "POST",
            data
        });
    },
    /**
     * 查看贴纸排版图
     * @param data
     */
    getStickerLayoutList(data={}) {
        return request({
            url:  '/service/mg/container/stickerLayoutList',
            method: "POST",
            data
        });
    },
    /**
     * 获取支付尾款列表
     * @param data
     */
    postFinalPayment(data) {
        return request({
            url: '/service/mg/warehouse-management/delivery-details/finalPayment',
            method: 'POST',
            data,
        })
    },
    /**
     * 下载六面图 | 下载质检图片
     * @param data
     */
    downloadPic(data,sType='') {
        let sUrl = '';
        if(sType == 'GoodsPic'){ // 六面图片
            sUrl =  '/service/mg/container/downloadGoodsPic';
        }else {//质检
            sUrl =  '/service/mg/container/downloadQualityTestingPic';
        }

        if(sType == 'OrderMsg'){
            sUrl =  '/service/mg/con/report/batch-download'
        }

        return request({
            url: sUrl,
            method: 'POST',
            data,
        })
    },
    /**
     * 循环获取下载图片压缩包
     * @param data
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#7264
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#7265
     */
    getDownloadPic(data={},sType='') {
        let sUrl = '';
        if(sType == 'GoodsPic'){ // 六面图片
            sUrl =  '/service/mg/container/getDownloadGoodsPicUrl'
        }else {//质检
            sUrl =  '/service/mg/container/getDownloadQualityTestingPicUrl'
        }


        if(sType == 'OrderMsg'){
            sUrl =  '/service/mg/con/report/batch-download-url'
        }
        return request({
            url: sUrl,
            method: "POST",
            data
        });
    },
    /**
     * 装箱单图片列表
     * @param data
     */
    getLoadContainerPic(data={}) {
        return request({
            url:  '/service/mg/container/queryLoadContainerPic',
            method: "POST",
            data
        });
    },
    /**
     * 更新随车单
     * @param data
     */
    updateTruckingListStatus(data={}) {
        return request({
            url:  '/service/mg/container/truckingListStatus',
            method: "POST",
            data
        });
    },
    /**
     * 更新 重新上传随车单 标志
     * @param data
     */
    uploadTruckingListMark(data={}) {
        return request({
            url:  '/service/mg/container/downloadTruckingListSign',
            method: "POST",
            data
        });
    },
     /**
     * 上传随车单
     * @param data
     */
    uploadTruckingList(data={}) {
        return request({
            url:  '/service/mg/container/uploadTruckingList',
            method: "POST",
            data
        });
    },

    /**
     * 下载装箱单图片
     * @param data
     */
    downloadLoadContainerPic(data) {
        return request({
            url: '/service/mg/container/downloadLoadContainerPic',
            method: 'POST',
            data,
        })
    },

    /**
     * 查询质检图片 检查列表
     * @param data
     */
    getCheckQualityPicList(data) {
        return request({
            url: '/service/mg/container/queryQualityPicList',
            method: 'POST',
            data,
        })
    },
    /**
     * 质检图片 检查 提交
     * @param data
     */
    updateQualityPicListStatu(data={}) {
        return request({
            url:  '/service/mg/container/saveQualityPicAudit',
            method: "POST",
            data
        });
    },
    /**
     * 查询历史纪录
     * @param data
     */
    getHistoryList(data={}) {
        return request({
            url:  '/service/mg/con/report/loadContainerOrder/historyLis',
            method: "POST",
            data
        });
    },
    /**
     * 表单自定义请求
     * @param data
     */
    autoFetchAction(data={},sUrl) {
        return request({
            url:  sUrl,
            method: "POST",
            data
        });
    }
};

export default SearchApiService;
